import { supabase } from '@/integrations/supabase/client';
import type { Database } from '@/integrations/supabase/types';
import type { NotificacaoTipo, NotificacaoDados } from '@/lib/notificacoes';

export interface Notificacao {
  id: string;
  tipo: NotificacaoTipo;
  dados: NotificacaoDados;
  lida: boolean;
  criado_em: string;
}

export type NotificacaoRow = Database['public']['Tables']['notificacoes']['Row'];

/** Lista as notificações do utilizador (mais recentes primeiro). */
export async function listarNotificacoes(userId: string): Promise<Notificacao[]> {
  const { data, error } = await supabase
    .from('notificacoes')
    .select('id, tipo, dados, lida, criado_em')
    .eq('user_id', userId)
    .order('criado_em', { ascending: false });
  if (error) throw error;
  return (data ?? []) as unknown as Notificacao[];
}

/** Conta as não-lidas do utilizador. */
export async function contarNaoLidas(userId: string): Promise<number> {
  const { count, error } = await supabase
    .from('notificacoes')
    .select('id', { count: 'exact', head: true })
    .eq('user_id', userId)
    .eq('lida', false);
  if (error) throw error;
  return count ?? 0;
}

/** Marca como lidas as notificações indicadas. */
export async function marcarLidas(ids: string[]): Promise<void> {
  const { error } = await supabase.rpc('marcar_notificacoes_lidas', { p_ids: ids });
  if (error) throw error;
}

/** Marca todas como lidas. */
export async function marcarTodasLidas(): Promise<void> {
  const { error } = await supabase.rpc('marcar_notificacoes_lidas', { p_ids: null });
  if (error) throw error;
}
